import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { memo } from "react";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const filter = createFilterOptions<options>({
  limit: 10000,
});

type options = {
  label: string;
  value: string;
};

type AutoCompleteCheckboxProps = {
  label: string;
  placeholder: string;
  options: options[];
  value?: options[];
  setValue?: (value: options[]) => void;
  size?: "small" | "medium";
};

type AutoCompleteProps = {
  label: string;
  placeholder: string;
  options: options[];
  value?: options | null;
  setValue?: (value: options | null) => void;
};

export const AutoCompleteCheckbox = memo(({ label, placeholder, options, value, setValue, size }: AutoCompleteCheckboxProps) => {
  return (
    <Autocomplete
      multiple
      id={label.toLowerCase().replace(/\s+/g, "-")}
      options={options}
      disableCloseOnSelect
      limitTags={5}
      filterOptions={filter}
      disableListWrap
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, value) => (value ? option.value === value.value : false)}
      value={value}
      onChange={(_event, newValue) => {
        setValue?.(newValue);
      }}
      renderOption={(props, option, { selected }) => {
        const { key, ...optionProps } = props;
        return (
          <li key={key} {...optionProps}>
            <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8 }} checked={selected} />
            {option.label}
          </li>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          size={size}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "10px",
              "& fieldset": {
                borderRadius: "10px",
              },
              "&:hover fieldset": {
                borderRadius: "10px",
              },
              "&.Mui-focused fieldset": {
                borderRadius: "10px",
              },
            },
          }}
        />
      )}
    />
  );
});

export const AutoComplete = memo(({ label, placeholder, options, value, setValue }: AutoCompleteProps) => {
  return (
    <Autocomplete
      id={label.toLowerCase().replace(/\s+/g, "-")}
      options={options}
      filterOptions={filter}
      disableListWrap
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, value) => (value ? option.value === value.value : false)}
      value={value}
      onChange={(_event, newValue) => {
        setValue?.(newValue);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "10px",
              "& fieldset": {
                borderRadius: "10px",
              },
              "&:hover fieldset": {
                borderRadius: "10px",
              },
              "&.Mui-focused fieldset": {
                borderRadius: "10px",
              },
            },
          }}
        />
      )}
      sx={{
        marginTop: "5px",
      }}
    />
  );
});
